export default function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<h2 class="underlined centered-container">Today\'s Best Travel Coupons</h2>\n<ul class="reset travel-coupon-container" id="coupon-collection"></ul>\n';
 if (this.collection.length < this.collection.total) { ;
__p += '\n  <div class="row centered-container">\n    <button class="rounded-button more-coupons large-4 medium-4 small-12">View More Coupons</button>\n  </div>\n';
 } ;
__p += '\n';
return __p
}